var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { SignalWatcher } from "@lit-labs/preact-signals";
import { draft } from "../state";
let ModeQuery = class ModeQuery extends SignalWatcher(LitElement) {
    constructor() {
        super(...arguments);
        this.routing = "practice";
    }
    static { this.styles = css `
    :host, *, *::before, *::after { box-sizing: border-box; }
    :host { display: block; }
    .intro h2 { font-family: var(--font-display); font-size: 13px; font-weight: 700; margin: 0 0 3px;
                text-transform: uppercase; letter-spacing: .05em; color: var(--color-slate-700); }
    .intro .sub { font-size: 12px; color: var(--color-slate-500); margin-bottom: 12px; }
    .hint { background: var(--color-blue-100); padding: 12px 14px; border-left: 4px solid var(--color-blue-600);
            border-radius: var(--radius-sm); margin-bottom: 12px; font-size: 13px; line-height: 1.5;
            color: var(--color-slate-700); }
    .manual { background: #F5F3FF; border: 1px solid #ddd6fe; padding: 10px 12px; border-radius: var(--radius-sm);
              margin-bottom: 12px; font-size: 12px; color: #7C3AED; display: flex; gap: 8px; align-items: flex-start; }
    textarea { box-sizing: border-box; width: 100%; min-height: 240px; resize: vertical;
               padding: 12px; border: 1px solid var(--color-slate-300);
               border-radius: var(--radius-md); font-family: var(--font-base); font-size: 14px; line-height: 1.55; }
    textarea:focus { outline: 2px solid var(--color-blue-500); outline-offset: -1px; border-color: var(--color-blue-500); }
    textarea::placeholder { color: var(--color-slate-400); line-height: 1.5; }
  `; }
    onInput(e) {
        const d = draft.value;
        draft.value = { ...d, query_text: e.target.value };
    }
    render() {
        const v = draft.value?.query_text ?? "";
        const manual = this.routing === "assessment-manual";
        return html `
      <div class="intro">
        <h2>Write a clinician query</h2>
        <div class="sub">The documentation is equivocal. Draft a query to the treating clinician.</div>
      </div>
      <div class="hint">
        Effective queries are clear and concise, cite the specific documentation gap, offer the
        reasonable options, and <strong>do not lead</strong> the clinician toward any particular diagnosis.
      </div>
      ${manual ? html `<div class="manual"><span>👤</span><span>This task is
        <strong>manually assessed</strong> by an assessor (routed via the assessment queue), not auto-marked.</span></div>` : ""}
      <textarea .value=${v} @input=${this.onInput}
                aria-label="Clinical query text" placeholder="Dear Dr…"></textarea>
    `;
    }
};
__decorate([
    property({ type: String })
], ModeQuery.prototype, "routing", void 0);
ModeQuery = __decorate([
    customElement("mode-query")
], ModeQuery);
export { ModeQuery };
